import { useSelector } from "react-redux";

const useSupplierHubStations = ({ receiverHubId }) => {
  const { allHubs } = useSelector((state) => state.locations);

  if (receiverHubId) {
    return allHubs
      .filter((item) => receiverHubId !== +item.hubId)
      .map((location) => ({
        id: location.id,
        value: location.name,
      }));
  }

  return allHubs.map((location) => ({
    id: location.id,
    value: location.name,
  }));
};

export default useSupplierHubStations;
